import { render } from "./AgroPriceText.vue?vue&type=template&id=5a726623&ts=true"
import script from "./AgroPriceText.vue?vue&type=script&lang=ts"
export * from "./AgroPriceText.vue?vue&type=script&lang=ts"

import "./AgroPriceText.vue?vue&type=style&index=0&id=5a726623&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__